export default "__VITE_ASSET__BYim2tf4__"